import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getWarningList, getMediaWallList, getOperatorLogList, getStrongAlarmInfo} from '@apis'
import moment from 'moment'

const InformationInfo = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId, brokerId} = userInfo
    const [energyWarningList, setEnergyWarningList] = useState([])
    const [nodeWarningList, setNodeWarningList] = useState([])
    const [operatorLogList, setOperatorLogList] = useState([])
  
    // 获取操作日志信息
    async function getOperatorLog() {
      const params = {
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getOperatorLogList(params)
      if (res && res.data) {
        const operatorLog = res.data.filter(item => {
          return item.brokerId==brokerId
        })
        setOperatorLogList(operatorLog)
      }
    }

    // 获取强电离线信息列表
    async function queryWarningList() {
      const params = {
        projectId,
        brokerId,
        pageNo: 1,
        pageSize: 9999
      }
      const res = projectId ? await getWarningList(params) : await getStrongAlarmInfo(params)
      if (res && res.data) {
        setEnergyWarningList(res.data.filter(item => item.r===false))
      }
    }

    // 获取节点离线信息列表
    async function queryNodeLogList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
      }
      if (brokerId > 0) {
        params.brokerId = brokerId
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        setNodeWarningList(res.data.filter(item => item.onlineStatus==0))
      }
    }
 
    useEffect(() => {
      getOperatorLog()
      queryWarningList()
      queryNodeLogList()
    }, [])

    return (
      
      <div className='ck-information'>
        <div className='ck-information-title'>消息日志</div>
        <div className='ck-information-item'>
          <div className='ck-information-left'>
            <div className='ck-operate-index'>
              {
                operatorLogList.map(item => (
                  <div className='ck-operate-log'>
                    <div className='ck-operate-time'>{moment(item.gmtCreate).format('YYYY.MM.DD HH:mm:ss')}</div>
                    <div className='ck-operate-name'>{item.title}</div>
                  </div>
                ))
              }
            </div>
          </div>
          <div className='ck-information-right'>
            <div className='ck-information-right-title'>报警信息</div>
            <div className='warning-index'>
              <div className='warning-title'>配电柜</div>
              <div className='warning-text'>
                {
                  energyWarningList.length ? energyWarningList.map(item => (
                    <div className='warning-item'>
                      <span className={`warning-name warning-name-${item.level}`}
                      >{item.t}</span>
                      <span>{item.hname}</span>
                      <div className={`warning-name warning-name-${item.level}`} style={{marginTop: "2px", paddingTop: "3px"}}>{item.msg}</div>
                    </div>
                  )) : (
                    <div className='warning-item'>
                      <span className='warning-name' style={{color: 'rgba(255, 255, 255, 0.7)'}}>一切正常</span>
                    </div>)
                }
              </div>
            </div>
            <div className='warning-index'>
              <div className='warning-title' style={{paddingTop: '28px'}}>节点</div>
              <div className='warning-text'>
                {
                  nodeWarningList.length ? nodeWarningList.map(item => (
                    <div className='warning-item'>
                      <span className='warning-name warning-name-2'
                      >{moment(item.offlineTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                      <span>{item.name}</span>
                      <span style={{marginLeft: '10px'}}>离线</span>
                    </div>
                  )) : (
                    <div className='warning-item'>
                      <span className='warning-name' style={{color: 'rgba(255, 255, 255, 0.7)'}}>一切正常</span>
                    </div>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default InformationInfo
